import { dispatchCommand } from '@/services/messaging/dispatchCommand';

export function formLogout () {
  return dispatchCommand("FormLogout");
}
